import React, { Component } from 'react'
import styled from 'styled-components'
import { styles } from '../../utils'
import chapman from '../../images/chapman.png'
import abyc from '../../images/abyc.png'
import uscg from '../../images/uscg.png'
// import sams from '../../images/sams.png'

export default class Certs extends Component {
  render() {
    return (
      <CertsWrapper>
        <center>
          <h3>Certifications</h3>
          <p>
            <ul>
              <li>
                Graduate of Chapmans School Of Seamanship / Yacht and Small
                Craft Surveying
              </li>
              <li>
                ABYC Certified Technician / ABYC Standards / ABYC Corrosion
                Specialist
              </li>
              USCG Certified Master Captain
              <li />
            </ul>
            <br />

            <center>
              <div class='row'>
                <img src={chapman} alt='Chapman School of Seamanship' />
                <img src={abyc} alt='American Boay and Yacht Council' />
                <img src={uscg} alt='United States Coast Guard' />
              </div>
            </center>

            <br />
            <hr />
          </p>
        </center>
      </CertsWrapper>
    )
  }
}

const CertsWrapper = styled.div`
  padding: 1rem 1rem;

  img {
    margin: 0 auto;
  }

  h3 {
    color: ${styles.colors.darkGold};
    font-size: 30px;
    font-weight: 500;
  }
  ul li {
    list-style: none;
    margin-top: 1rem;
  }
`
